export default "__VITE_ASSET__D8aLVXt1__"